export const RADIO_COMMANDS = [
    {
        "category": "RADIO_CAT_PREP",
        "commands": [
            { "id": "#Chatwheel_gogogo", "label": "RADIO_CMD_GOGOGO" },
            { "id": "#Chatwheel_onmyway", "label": "RADIO_CMD_ONMYWAY" },
            { "id": "#Chatwheel_followme", "label": "RADIO_CMD_FOLLOWME" },
            { "id": "#Chatwheel_coverme", "label": "RADIO_CMD_COVERME" },
            { "id": "#Chatwheel_regroup", "label": "RADIO_CMD_REGROUP" },
            { "id": "#Chatwheel_sticktogether", "label": "RADIO_CMD_STICKTOGETHER" },
            { "id": "#Chatwheel_holdposition", "label": "RADIO_CMD_HOLDPOS" },
            { "id": "#Chatwheel_fallback", "label": "RADIO_CMD_FALLBACK" },
            { "id": "#Chatwheel_spreadout", "label": "RADIO_CMD_SPREADOUT" },
            { "id": "#Chatwheel_split", "label": "RADIO_CMD_SPLIT" },
            { "id": "#Chatwheel_flank", "label": "RADIO_CMD_FLANK" }
        ]
    },
    {
        "category": "RADIO_CAT_REPORT",
        "commands": [
            { "id": "#Chatwheel_sectorclear", "label": "RADIO_CMD_SECTORCLEAR" },
            { "id": "#Chatwheel_peeking", "label": "RADIO_CMD_PEEKING" },
            { "id": "#Chatwheel_heardnoise", "label": "RADIO_CMD_HEARDNOISE" },
            { "id": "#Chatwheel_enemyfolks", "label": "RADIO_CMD_ENEMYSPOTTED" },
            { "id": "#Chatwheel_sniperspotted", "label": "RADIO_CMD_SNIPER" },
            { "id": "#Chatwheel_bombcarrierhere", "label": "RADIO_CMD_BOMBCARRIER" },
            { "id": "#Chatwheel_inposition", "label": "RADIO_CMD_INPOSITION" },
            { "id": "#Chatwheel_multipleenemies", "label": "RADIO_CMD_MULTIPLEENEMIES" },
            { "id": "#Chatwheel_oneenemyhere", "label": "RADIO_CMD_ONEENEMY" },
            { "id": "#Chatwheel_bombatA", "label": "RADIO_CMD_BOMBATA" },
            { "id": "#Chatwheel_bombatB", "label": "RADIO_CMD_BOMBATB" }
        ]
    },
    {
        "category": "RADIO_CAT_REQUEST",
        "commands": [
            { "id": "#Chatwheel_needbackup", "label": "RADIO_CMD_NEEDBACKUP" },
            { "id": "#Chatwheel_needsmoke", "label": "RADIO_CMD_NEEDSMOKE" },
            { "id": "#Chatwheel_needflash", "label": "RADIO_CMD_NEEDFLASH" },
            { "id": "#Chatwheel_needfire", "label": "RADIO_CMD_NEEDFIRE" },
            { "id": "#Chatwheel_needdecoy", "label": "RADIO_CMD_NEEDDECOY" },
            { "id": "#Chatwheel_needgrenade", "label": "RADIO_CMD_NEEDHE" },
            { "id": "#Chatwheel_needplan", "label": "RADIO_CMD_NEEDPLAN" }
        ]
    },
    {
        "category": "RADIO_CAT_ECO",
        "commands": [
            { "id": "#Chatwheel_requestweapon", "label": "RADIO_CMD_NEEDWEAPON" },
            { "id": "#Chatwheel_requestdrop", "label": "RADIO_CMD_REQUESTDROP" },
            { "id": "#Chatwheel_requestspend", "label": "RADIO_CMD_FULLBUY" },
            { "id": "#Chatwheel_requestecoround", "label": "RADIO_CMD_ECO" },
            { "id": "#Chatwheel_savedrop", "label": "RADIO_CMD_OFFERDROP" },
            { "id": "#Chatwheel_donate", "label": "RADIO_CMD_DONATE" }
        ]
    },
    {
        "category": "RADIO_CAT_PLAN",
        "commands": [
            { "id": "#Chatwheel_aplan", "label": "RADIO_CMD_PINGA" },
            { "id": "#Chatwheel_bplan", "label": "RADIO_CMD_PINGB" },
            { "id": "#Chatwheel_midplan", "label": "RADIO_CMD_PINGMID" },
            { "id": "#Chatwheel_rotatetome", "label": "RADIO_CMD_ROTATETOME" }
        ]
    },
    {
        "category": "RADIO_CAT_SOCIAL",
        "commands": [
            { "id": "#Chatwheel_affirmative", "label": "RADIO_CMD_AFFIRMATIVE" },
            { "id": "#Chatwheel_negative", "label": "RADIO_CMD_NEGATIVE" },
            { "id": "#Chatwheel_thanks", "label": "RADIO_CMD_THANKS" },
            { "id": "#Chatwheel_cheer", "label": "RADIO_CMD_CHEER" },
            { "id": "#Chatwheel_compliment", "label": "RADIO_CMD_COMPLIMENT" },
            { "id": "#Chatwheel_sorry", "label": "RADIO_CMD_SORRY" },
            { "id": "#Chatwheel_pep", "label": "RADIO_CMD_PEP" },
            { "id": "#Chatwheel_goosfraba", "label": "RADIO_CMD_QUIET_RELAX" },
            { "id": "#Chatwheel_quiet", "label": "RADIO_CMD_SILENCE" },
            { "id": "#Chatwheel_yep", "label": "RADIO_CMD_YES" },
            { "id": "#Chatwheel_nope", "label": "RADIO_CMD_NO" }
        ]
    }
];
